import { useTranslation } from 'react-i18next';

import { IngredientTabProps } from 'components/desktop/Ingredient/IngredientComponent';
import * as IngredientState from 'components/desktop/Ingredient/IngredientState';
import FoldableCard from 'components/desktop/_general/Card/FoldableCard/FoldableCard';
import SingleSearchSelectNew from 'components/desktop/_general/Select/SingleSearchSelect/SingleSearchSelectNew';
import { usePermissions } from 'hooks/usePermissions';
import * as BaseIngredientList from 'types/_general/Store/BaseIngredientList';

export const IngredientBaseIngredientCard = ({
	state,
	handlers,
	data,
}: IngredientTabProps): JSX.Element => {
	const { t } = useTranslation();

	const { isIngredientEditor } = usePermissions();

	return (
		<FoldableCard
			defaultOpen={true}
			dataComponentType="ingredient-baseingredient-card"
			title={t('ingredient:BASE_INGREDIENT')}
			content={
				<SingleSearchSelectNew
					allItems={BaseIngredientList.mapToSelectItemList(data.baseIngredients)}
					disabled={!isIngredientEditor}
					errorKey={'BaseIngredientId'}
					hideField={!isIngredientEditor}
					linkTo={IngredientState.getLinkToBaseIngredient(state)}
					savedItem={state.baseIngredientId}
					setSavedItem={handlers.setBaseIngredientId}
				/>
			}
			isInActive={false}
		/>
	);
};
